import { Component, OnInit } from '@angular/core';
import {AlwaysAuthGuard} from '../../Services/auth.service'
import { convertActionBinding } from '@angular/compiler/src/compiler_util/expression_converter';
 import { Router } from '@angular/router';

declare var config;

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class LayoutComponent implements OnInit {
 public currentuser:any
 public IsStoreupload= config.IsStoreupload;
  constructor(private router: Router,private access: AlwaysAuthGuard) { }

  ngOnInit() {
    if(sessionStorage.getItem('user'))
    {
      this.currentuser=JSON.parse(sessionStorage.getItem('user'));
    }

  }
 
  logout(){
    sessionStorage.removeItem('user');
     this.router.navigate(['/']);
  }

}
